import {
  getCategoryTimeSettings,
  getStoreDefaultMenu,
  getStoreMenus,
  getUpsellMenus,
} from "../../../api/services/storeService";
import {
  isMenuAvailable,
  getCurrentDate,
  setZone,
} from "../../../api/helpers/datetimeHelper.js";
import { parseQueryString } from "../../../api/helpers/commonHelpers.js";
import {
  CONSTANT_ORDER_TYPE_DELIVERY,
  CONSTANT_ORDER_TYPE_PICKUP,
  CONSTANT_ORDER_TYPE_DINEIN,
} from "./../../../constants/strings";
import { orderTypeHelper } from "../../../api/helpers/orderTypeHelper";
import { DateTime } from "luxon";
import { normalizeQueryParams } from "../../../api/helpers/uiHelper.js";

export default {
  state: {
    timer: null,
    updateTime: null,
    skipUpdateTime: false,
    storeMenus: [],
    loadedMenu: false,
    currentMenuId: "DefaultMenu",
    selectedStoreMenus: [],
    dietarySelection: { Allergy: [], Intolerance: [], Preference: [] },
    selectedMenuType: null,
    addToCartOpen: false,
    upsellMenus: [],
    CategoryTimeSettings: {},
  },
  mutations: {
    setCurrentMenuId(state, payload) {
      localStorage.setItem("currentMenuId", payload);
    },
    setTimer(state, payload) {
      state.timer = payload;
    },
    setSkipUpdateTime(state, payload) {
      state.skipUpdateTime = payload;
    },
    setMenuLoaded(state) {
      state.loadedMenu = true;
    },
    setMenuLoading(state) {
      state.loadedMenu = false;
    },

    setUpdateTime(state, payload) {
      state.updateTime = payload;
    },
    setStoreMenus(state, payload) {
      state.storeMenus = [];
      state.storeMenus = payload;
    },
    setUpsellMenus(state, payload) {
      state.upsellMenus = payload;
    },
    setCategoryTimeSettings(state, payload) {
      state.CategoryTimeSettings = payload;
    },
    setSelectedStoreMenus(state, payload) {
      state.selectedStoreMenus = [];
      state.selectedStoreMenus = payload;
    },
    setAllergySelected(state, selection) {
      state.dietarySelection.Allergy = selection;
    },
    setIntoleranceSelected(state, selection) {
      state.dietarySelection.Intolerance = selection;
    },
    setPreferenceSelected(state, selection) {
      state.dietarySelection.Preference = selection;
    },
    setSelectedMenuType(state, type) {
      state.selectedMenuType = type;
    },
    setAddToCartOpen(state, payload) {
      state.addToCartOpen = payload;
    },
  },
  actions: {
    async getGiftCardMenu(context, payload) {
      context.commit("setMenuLoading");

      getStoreDefaultMenu(payload).onSnapshot(async function (snapshot) {
        if (snapshot.exists) {
          context.commit("setStoreMenus", [ { id: snapshot.id, ...snapshot.data() } ]);
          // Process gift cards
          const menu = {
            id: snapshot.id,
            ...snapshot.data()
          }
          let temp = [];
          if (
            menu &&
            menu.SpecialCategories &&
            menu.SpecialCategories.SCTypeGiftcard &&
            menu.SpecialCategories.SCTypeGiftcard.SubMenuItems
          ) {
            menu.SpecialCategories.SCTypeGiftcard.SubMenuItems.forEach((element) => {
              if (element.ProductID) {
                if (menu.Products[element.ProductID]) {
                  const tempElement = JSON.parse(JSON.stringify(element));
                  tempElement.ShortDescription =
                    menu.Products[element.ProductID].ShortDescription;
                  tempElement.PhotoUrl = menu.Products[element.ProductID].PhotoUrl;
                  tempElement.Name = menu.Products[element.ProductID].Name;
                  tempElement.TaxRate = menu.Products[element.ProductID].TaxRate;

                  temp.push(tempElement);
                }
              }
            });
          }
          const result = temp.sort(function (a, b) {
            return a.Price > b.Price ? 1 : -1;
          });
          
          // Add default images
          const imageUrlList = ["card1.png", "card2.png", "card3.png", "card4.png"];
          result.forEach((element, index) => {
            element.DefaultImageUrl = imageUrlList[index % imageUrlList.length];
          });
          
          context.commit("newGiftShoppingCart/setStoreGiftCards", result);
          
          // Set default selected gift card if none selected
          if (result && result.length) {
            context.commit("newGiftShoppingCart/setCardSelected", result[0]);
          }
          
          context.dispatch("changeMenuState");
          context.commit("setMenuLoaded");
        }
      });
    },
    async getStoreMenu(context, payload) {
      context.commit("setMenuLoading");
      getStoreMenus(payload).onSnapshot(async function (snapshot) {
        var storeMenus = [];
        snapshot.docs.forEach(function (doc) {
          if (doc.exists) storeMenus.push({ id: doc.id, ...doc.data() });
        });
        context.commit("setStoreMenus", storeMenus);
        context.dispatch("changeMenuState");
        context.commit("setMenuLoaded");
        getUpsellMenus(payload).then((upsellMenus) => {
          context.commit("setUpsellMenus", upsellMenus);
        });
        getCategoryTimeSettings(payload, (ts) => {
          context.commit("setCategoryTimeSettings", ts);
        });
      });
    },
    async getSelectedStoreMenu(context, payload) {
      context.commit("setMenuLoading");
      getStoreMenus(payload).onSnapshot(async function (snapshot) {
        var storeMenus = [];
        snapshot.docs.forEach(function (doc) {
          if (doc.exists) storeMenus.push({ id: doc.id, ...doc.data() });
        });

        context.commit("setSelectedStoreMenus", storeMenus);
        context.commit("setMenuLoaded");
      });
    },

    changeMenuState(context) {
      if (context.state.timer) window.clearTimeout(context.state.timer);
      if (!context.state.skipUpdateTime)
        context.commit("setUpdateTime", new Date());
      context.dispatch("updateShoppingCartItems");
      context.commit(
        "setTimer",
        setTimeout(() => {
          context.dispatch("changeMenuState");
        }, 60000 * 5)
      );
    },
    clearStoreMenu(context) {
      context.commit("setCurrentMenuId", "DefaultMenu");
    },
    updateShoppingCartItems(context) {
      if (!context.getters.storeSelectionAtCheckoutMode) {
        let removedItems = [];
        context.getters.cartItems.forEach((item) => {
          // All the  products will be unique in ProductStatus
          if (context.getters.productStatuses[item.id.toString()] === 3) {
            removedItems.push(item);
          }
        });
        removedItems.forEach((item) => {
          context.commit("REMOVE_CART_ITEM", { item: item });
        });
      }
    },

    async toggleAddToCartOpen(context, payload) {
      context.commit("setAddToCartOpen", payload);
    },
  },
  getters: {
    getProductById: (state, getters) => (productId) => {
      if (getters.storeMenu) return getters.storeMenu.Products[productId];
      else return null;
    },
    getProductFromCategories: (state, getters) => (productId) => {
      if (getters.storeMenu)
        return getters.storeMenu.Categories.flatMap((x) => x.SubMenuItems).find(
          (p) => p.ProductID == productId
        );
      else return null;
    },
    getAllStoreMenus(state) {
      return state.storeMenus;
    },
    upsellMenus(state) {
      return state.upsellMenus;
    },
    categoryTimeSettings(state) {
      return state.categoryTimeSettings || {};
    },
    storeMenu(state, getters) {
      let storeMenu = null;
      storeMenu = getters.storeMenuWithMenuName(getters.getSelectedMenuType);
      return storeMenu;
    },

    storeMenuWithMenuName: (state, getters) => (menuType) => {
      if (!menuType) {
        menuType = orderTypeHelper.getOrderType();
      }
      let storeMenu = null;
      let supportMultipleMenu = getters.multipleMenuEnabled;
      const ooMenus = getters.ooMenus;
      const query = parseQueryString();
      const normalizedQuery = normalizeQueryParams(query);
      if (normalizedQuery['guestcount']) {
        const guestCount = Number(normalizedQuery['guestcount']);
        const plSettings = getters.paylaterSettings;
        if (plSettings.Enabled) {
          if (guestCount <= plSettings.MaxPax) {
            return ooMenus.find((x) => x.MenuTag == "Small");
          } else {
            return ooMenus.find((x) => x.MenuTag == "Large");
          }
        }
      }
      if (query.menu && ooMenus.some((x) => x.MenuName == query.menu)) {
        storeMenu = ooMenus.find((x) => x.MenuName == query.menu);
        return storeMenu;
      }
      let selectedTs = getters.selectedTS(menuType);
      if (menuType && supportMultipleMenu) {
        switch (menuType) {
          case CONSTANT_ORDER_TYPE_DELIVERY:
            storeMenu = ooMenus.find(
              (x) =>
                (!selectedTs || x.MenuID == selectedTs.MenuId) &&
                x.OrderTypes &&
                x.OrderTypes.Delivery === true
            );
            break;
          case CONSTANT_ORDER_TYPE_PICKUP:
            storeMenu = ooMenus.find(
              (x) =>
                (!selectedTs || x.MenuID == selectedTs.MenuId) &&
                x.OrderTypes &&
                x.OrderTypes.Takeaway === true
            );
            break;

          case CONSTANT_ORDER_TYPE_DINEIN:
            storeMenu = ooMenus.find(
              (x) =>
                (!selectedTs || x.MenuID == selectedTs.MenuId) &&
                x.OrderTypes &&
                x.OrderTypes.EatIn === true
            );
            break;
        }
      } else if (selectedTs) {
        storeMenu = ooMenus.find((x) => x.MenuID == selectedTs.MenuId);
      }

      storeMenu =
        storeMenu || state.storeMenus.find((p) => p.id == "DefaultMenu");
      return storeMenu;
    },
    selectedTS: (state, getters) => (menuType) => {
      let menuTS = [];
      let now = getCurrentDate(
        getters.currentStoreDoc
          ? getters.currentStoreDoc.TimezoneIanaFormat
          : null
      );
      let menuMode = menuType || getters.getSelectedMenuType;
      let multipleMenus = getters.multipleMenuEnabled;
      // if (!multipleMenus) {
      //   if (getters.selectedCompany.PickUp) {
      //     menuMode = CONSTANT_ORDER_TYPE_PICKUP;
      //   } else if (getters.selectedCompany.Delivery) {
      //     menuMode = CONSTANT_ORDER_TYPE_DELIVERY;
      //   } else if (getters.selectedCompany.EatIn) {
      //     menuMode = CONSTANT_ORDER_TYPE_DINEIN;
      //   }
      // }
      if (
        getters.getMenuTimeSettings &&
        getters.getMenuTimeSettings.length > 0 &&
        !getters.storeSelectionAtCheckoutMode
      ) {
        let orderType = orderTypeHelper.mapOrderType(menuMode);

        menuTS = (getters.getMenuTimeSettings || []).filter((ts) => {
          let menu = getters.ooMenus.find((x) => x.MenuID == ts.MenuId);
          if (!menu) {
            return false;
          }
          let orderTypeMatch =
            !orderType || (menu.OrderTypes && menu.OrderTypes[orderType]);

          if (
            !multipleMenus ||
            !menu.OrderTypes ||
            Object.keys(menu.OrderTypes).length == 0
          ) {
            orderTypeMatch = true;
          }
          let timeMatch = isMenuAvailable(now, ts);
          return orderTypeMatch && timeMatch;
        });
      }
      let tsCandidate = menuTS.length > 0 ? menuTS[0] : null;
      if (tsCandidate && menuMode) {
        let preorder = tsCandidate.dateTime > now;
        if (
          menuMode &&
          menuMode == CONSTANT_ORDER_TYPE_PICKUP &&
          preorder &&
          !getters.selectedCompany.EnablePreoderForPickup
        ) {
          return null;
        }
        if (
          menuMode &&
          menuMode == CONSTANT_ORDER_TYPE_DELIVERY &&
          preorder &&
          !getters.selectedCompany.EnablePreoderForDelivery
        ) {
          return null;
        }
        //disable preorder for dine in
        if (menuMode && menuMode == CONSTANT_ORDER_TYPE_DINEIN && preorder) {
          return null;
        }
      }

      return tsCandidate;
    },
    multipleMenuEnabled(state, getters) {
      let multipleMenus = false;
      if (
        getters.selectedCompany &&
        getters.selectedCompany.ViewComponentConfigs &&
        getters.selectedCompany.ViewComponentConfigs.MultipleMenus === true
      ) {
        multipleMenus = true;
      }
      return multipleMenus;
    },
    tsMenuAvailable(state, getters) {
      if (
        getters.getMenuTimeSettings &&
        getters.getMenuTimeSettings.length > 0 &&
        !getters.selectedTS()
      ) {
        return false;
      }
      return true;
    },
    menuUnAvailable(state, getters) {
      if (
        !getters.multipleMenuEnabled ||
        (getters.multipleMenuEnabled && (getters.getMenuTimeSettings && getters.getMenuTimeSettings.length === 0))
      ) {
        return getters.storeClosed;
      } else {
        return !getters.tsMenuAvailable;
      }
    },
    ooMenus(state) {
      return state.storeMenus.filter((m) => {
        if (m.Platforms) {
          return (
            m.Platforms.AbacusOnlineOrdering == true &&
            m.Platforms.OnlineOrdering == true
          );
        } else {
          return false;
        }
      });
    },
    UnavailableCategories(state, getters) {
      const uc = [];
      if (
        getters.storeMenu &&
        getters.storeMenu.id &&
        state.CategoryTimeSettings
      ) {
        const ts =
          state.CategoryTimeSettings[
            getters.storeMenu.MenuID || getters.storeMenu.id
          ];
        if (ts && ts.Categories) {
          const zone = getters.currentStoreDoc
            ? getters.currentStoreDoc.TimezoneIanaFormat
            : null;
          const now = getCurrentDate(zone);
          const day = now.weekday == 7 ? 0 : now.weekday;
          for (const ct in ts.Categories) {
            const hasAnyTimeSetting =
              Object.keys(ts.Categories[ct] || {}).length > 0;
            const times = ts.Categories[ct][day];
            if (times && times.length > 0) {
              const valid = times.some((t) => {
                let from = DateTime.fromFormat(t.From, "HH:mm");
                let to = DateTime.fromFormat(t.To, "HH:mm");
                from = setZone(from, zone);
                to = setZone(to, zone);
                return now > from && now < to;
              });
              if (!valid) {
                uc.push(ct);
              }
            } else {
              if (hasAnyTimeSetting) {
                uc.push(ct);
              }
            }
          }
        }
      }
      return uc;
    },
    getloadedMenu(state) {
      return state.loadedMenu;
    },
    selectedStoreMenus(state) {
      return state.selectedStoreMenus;
    },
    getUsedLifeStyles(state, getters) {
      if (getters.getMenuLifeStyles && getters.getMenuLifeStyles.length > 0) {
        if (getters.storeMenu && getters.storeMenu.Categories) {
          var allergies = getters.getMenuLifeStyles[0].Allergy.filter((p) =>
            getters.storeMenu.Categories.some((a) =>
              a.SubMenuItems.some(
                (a2) =>
                  a2.ProductAllergy && a2.ProductAllergy.indexOf(p.Id) > -1
              )
            )
          ).map((p) => {
            return {
              ...p,
              isSelected:
                state.dietarySelection &&
                state.dietarySelection.Allergy &&
                state.dietarySelection.Allergy.some((s) => s.Id == p.Id),
            };
          });
          var intolerances = getters.getMenuLifeStyles[0].Intolerance.filter(
            (p) =>
              getters.storeMenu.Categories.some((a) =>
                a.SubMenuItems.some(
                  (a2) =>
                    a2.ProductIntolerance &&
                    a2.ProductIntolerance.indexOf(p.Id) > -1
                )
              )
          ).map((p) => {
            return {
              ...p,
              isSelected:
                state.dietarySelection &&
                state.dietarySelection.Intolerance &&
                state.dietarySelection.Intolerance.some((s) => s.Id == p.Id),
            };
          });
          var preferences = getters.getMenuLifeStyles[0].Preference.filter(
            (p) =>
              getters.storeMenu.Categories.some((a) =>
                a.SubMenuItems.some(
                  (a2) =>
                    a2.ProductPreference &&
                    a2.ProductPreference.indexOf(p.Id) > -1
                )
              )
          ).map((p) => {
            return {
              ...p,
              isSelected:
                state.dietarySelection &&
                state.dietarySelection.Preference &&
                state.dietarySelection.Preference.some((s) => s.Id == p.Id),
            };
          });
          return {
            allergies: allergies,
            intolerances: intolerances,
            preferences: preferences,
          };
        }
      }
      return {
        allergies: [],
        intolerances: [],
        preferences: [],
      };
    },
    getDietarySelection(state) {
      return state.dietarySelection;
    },
    getMenuTypes(state) {
      var types = [
        CONSTANT_ORDER_TYPE_DELIVERY,
        CONSTANT_ORDER_TYPE_DINEIN,
        CONSTANT_ORDER_TYPE_PICKUP,
      ];
      return types.filter((p) => state.storeMenus.some((s) => s.MenuName == p));
    },
    getSelectedMenuType(state) {
      return state.selectedMenuType;
    },

    getAddToCartOpen(state) {
      return state.addToCartOpen;
    },

    getDefaultMenu(state) {
      if (state.storeMenus.length === 0) return null;
      const storeMenu = state.storeMenus.find((p) => p.id == "DefaultMenu");
      return Object.keys(storeMenu).length === 0 ? null : storeMenu;
    },
  },
};
